import { render, staticRenderFns } from "./MedicalConsent.vue?vue&type=template&id=537b5504&scoped=true&"
import script from "./MedicalConsent.vue?vue&type=script&lang=js&"
export * from "./MedicalConsent.vue?vue&type=script&lang=js&"
import style0 from "./MedicalConsent.vue?vue&type=style&index=0&id=537b5504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b5504",
  null
  
)

export default component.exports